import React, { createContext, useEffect, useState } from "react";

// Create context
export const AppContext = createContext();

// Provider component
export const AppProvider = ({ children }) => {
  const [isOpenDrawer, setOpenDrawer] = useState(false); // example state
  const [isHome, setHome] = useState(false);
  const [isVipModal, setVipModal] = useState(false); // example state
  const [discountText, setDiscountText] = useState(null);
  const [discount, setDiscount] = useState(null);

  return (
    <AppContext.Provider
      value={{
        isOpenDrawer,
        setOpenDrawer,
        isHome,
        setHome,
        isVipModal,
        setVipModal,
        discountText,
        setDiscountText,
        discount,
        setDiscount,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
